import ConfirmationSummary from './ConfirmationSummary';

export default ConfirmationSummary;
